import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlDriver extends Layout {
    checkboxAddCallin: Checkbox;
    checkboxAddDriverEvent: Checkbox;
    checkboxDriverLogin: Checkbox;
    checkboxDriverLogout: Checkbox;
    checkboxSlipSeatLogin: Checkbox;
    checkboxSlipSeatLogout: Checkbox;
    checkboxUpdateCallinRemarks: Checkbox;
    checkboxUpdatePtaDate: Checkbox;
    panelDriverOne: Panel;
    panelDriverSection: Panel;
    panelDriverThree: Panel;
    panelDriverTwo: Panel;
    sourceMCExAppControl: DataSource;
    textFieldAccepted: Textbox;
    textFieldAvailableDate: Textbox;
    textFieldAvailableTime: Textbox;
    textFieldCallinRemarks: Textbox;
    textFieldDriverOrTractor: Textbox;
    textFieldDriverRemarks: Textbox;
    textFieldOrderNumber: Textbox;
    textFieldSlipSeatDriverOrTractor: Textbox;
    textFieldTimeField: Textbox;
    textFieldTimeOffDate: Textbox;
    textFieldTimeOffTime: Textbox;
}
